export const scrollbarInnerWidth = 6;
export const scrollbarMargin = 2;
export const scrollbarWidth = scrollbarInnerWidth + 2 * scrollbarMargin;
export const nativeScrollbars = (theme, ampersands) => {
    const scrollbarBackground = theme.colors.apolloColorFillScrollbar;
    const scrollbarBackgroundHover = theme.colors.apolloColorFillScrollbarHover;
    return {
        // All browsers that support -webkit-scrollbar (Chrome, Edge, Opera, Safari)
        // this is to solve the bug (APO-2261) until all features have APC 7.21.1+
        "@supports selector(::-webkit-scrollbar)": {
            [`${ampersands} *`]: {
                scrollbarWidth: "auto !important",
                scrollbarColor: "auto !important",
            },
        },
        // Firefox
        "@supports not selector(::-webkit-scrollbar)": {
            [`${ampersands} *`]: {
                scrollbarWidth: "thin",
                scrollbarColor: `${scrollbarBackground} transparent`,
            },
        },
        [`${ampersands} *::-webkit-scrollbar`]: {
            width: `${scrollbarWidth}px`,
            height: `${scrollbarWidth}px`,
        },
        [`${ampersands} *::-webkit-scrollbar-track`]: {
            background: "transparent",
        },
        [`${ampersands} *::-webkit-scrollbar-thumb`]: {
            border: `${scrollbarMargin}px solid transparent`,
            borderRadius: `${scrollbarWidth}px`,
            boxShadow: `inset 0 0 0 ${scrollbarWidth}px`,
            color: scrollbarBackground,
            transition: "color 0.3s", // doesn't work
        },
        [`${ampersands} *::-webkit-scrollbar-thumb:hover`]: {
            color: scrollbarBackgroundHover,
        },
        [`${ampersands} *::-webkit-scrollbar-corner`]: {
            background: "transparent",
        },
    };
};
//# sourceMappingURL=nativeScrollbars.js.map